import { createContext } from 'react';
import { ISwipeDialogContext } from './models';

export const SwipeDialogContext = createContext<ISwipeDialogContext>({
  swipeController: null,
});
